/**
 * @file This file contains configuration for different types of NPCs (Non-Player Characters).
 * @module npcConfig
 */

/**
 * @typedef {Object} NpcTypeConfig
 * @property {string} type - The general type of the NPC (e.g., 'NPC', 'NonHumanNPC').
 * @property {boolean} isHuman - Indicates if the NPC is a human character.
 * @property {string} configKey - The key used to reference the list of characters for this NPC type in other configurations.
 * @property {number|null} maxSpawns - The maximum number of this NPC type that can be spawned, or null if unlimited.
 * @property {string} overlayPrefix - The prefix used for the DOM element IDs when displaying this NPC type on an overlay.
 */

/**
 * Configuration object for different NPC types.
 * @type {Object}
 * @property {NpcTypeConfig} human - Configuration for human NPCs.
 * @property {NpcTypeConfig} nonHuman - Configuration for non-human NPCs.
 */
export const npcConfig = {
    human: {
        type: 'NPC',
        isHuman: true,
        configKey: 'npcs',
        maxSpawns: 5,
        overlayPrefix: 'npc-'
    },
    nonHuman: {
        type: 'NonHumanNPC',
        isHuman: false,
        configKey: 'nonHumanNpcs',
        maxSpawns: 5,
        overlayPrefix: 'nonhuman-npc-'
    }
};